import { useCart } from '../../../hooks/useCart';
import Money from '../../Money';
import React from 'react';

/**
 * First order Sub & Save code. Kept in step with the `sub_save_discount_code`
 * assign in snippets/cart-summary.liquid.
 */
const SUB_SAVE_FIRST_ORDER_DISCOUNT_CODE = '25SUB';

type MiniCartCheckoutButtonProps = {
  children: React.ReactNode;
};

export function MiniCartCheckoutButton({
  children,
}: MiniCartCheckoutButtonProps): JSX.Element {
  const { cart } = useCart();
  const subtotal = cart.total_price || cart.original_total_price;

  /**
   * A subscription cart with no code on it yet goes to checkout via
   * /discount/<code>, which is the only mechanism Shopify supports for
   * applying a code from the storefront. Anything else follows the href.
   */
  const handleCheckoutClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (!cart.item_count) {
      return;
    }

    const hasSubscriptionItem = cart.items.some((item) => Boolean(item.selling_plan_allocation));
    const hasDiscountCode = Boolean(cart.discount_codes && cart.discount_codes.length);

    if (!hasSubscriptionItem || hasDiscountCode) {
      return;
    }

    event.preventDefault();
    window.location.href = `/discount/${encodeURIComponent(SUB_SAVE_FIRST_ORDER_DISCOUNT_CODE)}?redirect=${encodeURIComponent('/checkout')}`;
  };

  return (
    <a href={cart.item_count ? '/checkout/' : '#'} className="minicart-checkout-button" onClick={handleCheckoutClick}>
      <i className="fas fa-lock"></i>
      <div>
        <span>{children}</span>
        <span>・</span>
        <Money amount={subtotal} />
      </div>
    </a>
  );
}
